<div class="park-rooms">
  <h4 class="park-title">Seleccione su habitación</h4>
  <p class="park-nights" *ngIf="nights">Precio total por {{ nights }} noche{{ nights > 1 ? 's' : '' }}</p>

  <div class="park-card" *ngFor="let card of cards; trackBy: trackByType" [class.selected]="isCardSelected(card)"
       [style.border-color]="isCardSelected(card) ? buttonColorActive : null">
    <img class="park-card-img" [src]="card.image" alt="{{ card.roomType.name }}">

    <div class="park-card-body">
      <p class="park-card-name">{{ card.roomType.name }}</p>
      <p class="park-card-meta">
        <span *ngIf="card.roomType.beds">{{ card.roomType.beds }} · </span>hasta {{ card.roomType.maxAdults }} adulto{{ card.roomType.maxAdults === 1 ? '' : 's' }}
      </p>

      <!-- Una fila por proveedor -->
      <div class="park-provider" *ngFor="let row of card.rows; trackBy: trackByProvider" [class.selected]="isSelected(card, row)">
        <div class="park-provider-id">
          <img *ngIf="row.provider.logo" class="park-provider-logo" [src]="row.provider.logo" alt="{{ row.provider.name }}">
          <span *ngIf="!row.provider.logo" class="park-provider-name">{{ row.provider.name }}</span>
          <p class="park-provider-cancel" [class.refundable]="row.refundable">
            <ng-container *ngIf="row.refundable; else nonRefundable">
              <strong>REEMBOLSABLE</strong><span *ngIf="row.cancelFrom"> - Penalidad desde el {{ row.cancelFrom | date:'dd MMM yyyy' }}</span>
            </ng-container>
            <ng-template #nonRefundable><strong>NO REEMBOLSABLE</strong></ng-template>
          </p>
        </div>

        <div class="park-provider-price">
          <p class="park-price">
            {{ currencyAgency?.code }} {{ row.price | currencyConverterPure: row.currency: currencyAgency?.code: currencies | number: '1.2-2' }}
            <usb-tooltip-convert-amount *ngIf="clientSetting"
                                        [clientsSettingAppBooking]="clientSetting"
                                        [currencyProduct]="row.currency"
                                        [valueProduct]="row.price">
            </usb-tooltip-convert-amount>
          </p>
          <small>imp. incluidos</small>
        </div>

        <button type="button" class="park-btn" [style.background-color]="buttonColorActive" (click)="pick(card, row)">
          {{ isSelected(card, row) ? 'Seleccionada' : 'Seleccionar' }}
        </button>
      </div>
    </div>
  </div>
</div>
